import { render, staticRenderFns } from "./ChangeViewBtn.vue?vue&type=template&id=5eda958c&scoped=true"
import script from "./ChangeViewBtn.vue?vue&type=script&lang=js"
export * from "./ChangeViewBtn.vue?vue&type=script&lang=js"
import style0 from "./ChangeViewBtn.vue?vue&type=style&index=0&id=5eda958c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda958c",
  null
  
)

export default component.exports